<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getTender">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Tender Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.tender_number" 
                        type="text" 
                        class="form-control" 
                        placeholder="Tender Number" 
                        aria-label="Tender Number" 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Tender Date</label>
                    <Datepicker 
                      v-model="search.tender_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-1 align-self-end">
                    <button type="submit" class="btn btn-sm btn-primary mb-0">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs fw-bolder">Tender Number</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Description</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Tender Deadline</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Tender Stage</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Last Date of Portal Access</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Delivery Date</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Payment Terms</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Purchase Representative</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tender in tender_list" :key="tender.purchase_tender_id">
                      <td>
                          <router-link :to="'/tender/' + tender.purchase_tender_id" class="text-xs text-primary fw-bold mb-0 ps-3">
                            {{ tender.tender_name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ tender.description }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ tender.sh_agreement_deadline }}</p>
                      </td>
                      <td>
                        <span class="badge badge-sm bg-success" v-if="tender.state_bid !== 'rejected'">{{ tender.stage_name }}</span>
                        <span class="badge badge-sm bg-danger" v-else>REJECTED</span>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ tender.sh_last_date_of_portal_access }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ tender.sh_delivery_date }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ tender.payment_term_name }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ tender.purchase_user_name }}</p>
                      </td>
                      <td class="align-middle text-sm">
                        <span class="badge badge-sm bg-primary" v-if="tender.state_bid !== 'rejected'">{{ tender.state }}</span>
                        <span class="badge badge-sm bg-danger" v-else>REJECTED</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!tender_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "tender",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    EmptyState,
    LoadingState
    // ArgonInput
  },
  data() {
    return {
      search: {
          tender_number: null,
          tender_date: [],
          delivery_date: [],
      },
      tender_list: [],
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      record_more: false,
      offset: 0,
      already_bid: false,
      rfp_rejected: false,
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getTender()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getTender()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    // async alreadyBid(tender_name) {
    //   var result = false
    //   await this.axios
    //     .post(
    //       endpoint.BIDDING_LIST,
    //       {
    //         name: tender_name,
    //         partner_id: parseInt(localStorage.getItem("partner_id")),
    //         limit: 1,
    //         offset: 0,
    //       },
    //       {
    //         headers: {
    //           Authorization: `Bearer ${localStorage.getItem("token")}`
    //         }
    //       }
    //     )
    //     .then((response) => {
    //       if (response.data.msg_status === "0002"){
    //           this.$notify({
    //             type: 'warn',
    //             title: 'Expired',
    //             text: 'Session expired, please sign in again.',
    //           });
    //           this.$router.replace('/signin')
    //           return false
    //       } else if (response.data.response_code === "0000") {
    //         // this.tender = response.data.data;
    //         if (response.data.data.every(function(rfp){ return rfp.state_value === 'rejected'})) {
    //           result = true
    //         } else {
    //           result = false
    //         }
    //       } else {
    //         return false
    //       }
    //     })
    //     .catch((e) => {
    //       this.$notify({
    //           type: 'error',
    //           title: 'Something went wrong!',
    //           text: e.response.data.message || e,
    //       });
    //     });
    //     return result
    // },
    getTender() {
      this.tender_list = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const tender_daterange = this.getDate(this.search.tender_date)
      let offset = 0
      if (tender_daterange.length > 0 || this.search.tender_number) {
        offset = 0
      } else {
        offset = this.offset
      }
      this.axios
        .post(
          endpoint.TENDER_LIST,
          {
            partner_id: parseInt(localStorage.getItem("partner_id")),
            name: this.search.tender_number || '',
            date_from: tender_daterange.length > 0 ? tender_daterange[0] : '',
            date_to: tender_daterange.length > 1 ? tender_daterange[1] : '',
            state: ["bid_selection","closed"],
            limit: 10,
            offset: offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
            this.tender_list = response.data.data;
          } else {
            if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
            } else if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message || e,
          });
          this.loading = false
        });
    }
  },
  mounted() {
    this.getTender();
  }
};
</script>

<style>

</style>